<template>
  <div class="navbar">
    <div class="navbar-container">
      <div class="navbar-left">
        <router-link to="/" class="logo">
          <img src="@/assets/logo.png" alt="Autozhuan">
          <span>Autozhuan</span>
        </router-link>
        <!-- 汉堡菜单按钮（手机端显示） -->
        <button class="hamburger-btn" @click="toggleMenu" :class="{ active: isMenuOpen }">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <!-- 导航菜单 -->
        <div class="nav-menu" :class="{ active: isMenuOpen }">
          <router-link to="/" class="nav-item" @click="closeMenu">首页</router-link>
          <router-link to="/download" class="nav-item" @click="closeMenu">软件下载</router-link>
          <router-link to="/membership-pricing" class="nav-item" @click="closeMenu">会员定价</router-link>
          <router-link to="/product-intro" class="nav-item" @click="closeMenu">产品介绍</router-link>
          <!-- <router-link to="/case-show" class="nav-item" @click="closeMenu">案例展示</router-link> -->
          <router-link to="/community" class="nav-item" @click="closeMenu">用户社区</router-link>
          <router-link to="/documentation" class="nav-item" @click="closeMenu">说明文档</router-link>
        </div>
      </div>
      <div class="navbar-right">
        <template v-if="!userStore.token">
          <div class="auth-buttons">
            <router-link to="/login" class="login-btn">登录</router-link>
            <router-link to="/register" class="register-btn">注册</router-link>
          </div>
        </template>
        <template v-else>
          <el-dropdown>
            <span class="user-info">
              <el-avatar :size="32" :src="getBackendUrl(userStore.userInfo?.avatar)" />
              <span class="username">{{ userStore.userInfo?.username }}</span>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <router-link to="/user-center">用户中心</router-link>
                </el-dropdown-item>
                <el-dropdown-item divided @click="handleLogout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </div>
    </div>
    <!-- 遮罩层（手机端） -->
    <div class="menu-overlay" :class="{ active: isMenuOpen }" @click="closeMenu"></div>
  </div>
</template>

<script>
import { useUserStore } from '@/store/modules/user'
import { ElMessageBox } from 'element-plus'
import { getBackendUrl } from '@/utils/backendUrlUtils'
import { ref, onMounted, onUnmounted } from 'vue'

export default {
  name: 'Navbar',
  setup() {
    console.log('Navbar setup')
    const userStore = useUserStore()
    const isMenuOpen = ref(false)
    
    const toggleMenu = () => {
      isMenuOpen.value = !isMenuOpen.value
    }
    
    const closeMenu = () => {
      isMenuOpen.value = false
    }
    
    const handleResize = () => {
      // 窗口大小变化时，如果窗口宽度大于768px，关闭菜单
      if (window.innerWidth > 768) {
        closeMenu()
      }
    }
    
    onMounted(() => {
      window.addEventListener('resize', handleResize)
    })
    
    onUnmounted(() => {
      window.removeEventListener('resize', handleResize)
    })
    
    const handleLogout = () => {
      ElMessageBox.confirm('确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const result = await userStore.handleLogout()
        if (result.success) {
          window.location.reload()
        } else {
          ElMessageBox.alert(result.message, '错误', {
            confirmButtonText: '确定',
            type: 'error',
            dangerouslyUseHTMLString: true
          }).catch(() => {
          // 用户点击关闭按钮，忽略错误
          })
        }
      }).catch(() => {})
    }
    
    return {
      userStore,
      isMenuOpen,
      toggleMenu,
      closeMenu,
      handleLogout,
      getBackendUrl
    }
  }
}
</script>

<style scoped>
.navbar {
  height: 80px;
  background-color: #191919;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10; /* 合理的z-index值，不会覆盖页面内容 */
  transition: all 0.3s ease;
}

.navbar-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 30px;
  transition: all 0.3s ease;
}

.navbar-left {
  display: flex;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  margin-right: 40px;
  text-decoration: none;
  color: white;
  font-weight: bold;
}

.logo {
  display: flex;
  align-items: center;
  margin-right: 60px;
  text-decoration: none;
  color: white;
  font-weight: bold;
  font-size: 24px;
  transition: all 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.logo img {
  height: 42px;
  margin-right: 12px;
  filter: brightness(0) invert(1);
  transition: all 0.3s ease;
}

.nav-menu {
  display: flex;
  align-items: center;
  gap: 30px;
}

.nav-item {
  text-decoration: none;
  color: white;
  font-size: 18px;
  font-weight: 500;
  transition: all 0.3s ease;
  padding: 8px 16px;
  position: relative;
}

.nav-item:hover {
  color: #f27303 !important;
}

.nav-item:hover::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 16px;
  right: 16px;
  height: 2px;
  background-color: #f27303;
}

.nav-item.router-link-active {
  color: #f27303 !important;
}

.nav-item.router-link-active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 16px;
  right: 16px;
  height: 2px;
  background-color: #f27303;
}

.navbar-right {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .auth-buttons {
    display: flex;
    align-items: center;
    gap: 15px;
    white-space: nowrap;
  }

  .login-btn,
  .register-btn {
    padding: 12px 28px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    text-decoration: none;
    transition: all 0.3s ease;
    border: 2px solid transparent;
    white-space: nowrap;
  }

.login-btn {
  color: white;
  border-color: #f27303;
  background: transparent;
}

.login-btn:hover {
  background-color: #f27303;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(242, 115, 3, 0.4);
}

.register-btn {
  background: linear-gradient(135deg, #f27303 0%, #e66800 100%);
  color: white;
  border: none;
  box-shadow: 0 4px 12px rgba(242, 115, 3, 0.3);
}

.register-btn:hover {
    background: linear-gradient(135deg, #e66800 0%, #d95d00 100%);
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(242, 115, 3, 0.5);
  }

  /* 响应式设计 */
  @media (max-width: 1400px) {
    .navbar-container {
      padding: 0 25px;
    }
    
    .logo {
      margin-right: 40px;
      font-size: 22px;
    }
    
    .logo img {
      height: 38px;
    }
    
    .nav-menu {
      gap: 25px;
    }
    
    .nav-item {
      font-size: 17px;
      padding: 6px 14px;
    }
  }

  @media (max-width: 1200px) {
    .navbar-container {
      padding: 0 20px;
    }
    
    .logo {
      margin-right: 30px;
      font-size: 20px;
    }
    
    .logo img {
      height: 36px;
    }
    
    .nav-menu {
      gap: 20px;
    }
    
    .nav-item {
      font-size: 16px;
      padding: 5px 12px;
    }
    
    .login-btn,
    .register-btn {
      padding: 10px 24px;
      font-size: 15px;
    }
  }

  @media (max-width: 1024px) {
    .navbar {
      height: 70px;
    }
    
    .navbar-container {
      padding: 0 15px;
    }
    
    .logo {
      margin-right: 20px;
      font-size: 18px;
    }
    
    .logo img {
      height: 32px;
    }
    
    .nav-menu {
      gap: 15px;
    }
    
    .nav-item {
      font-size: 15px;
      padding: 4px 10px;
    }
    
    .navbar-right {
      gap: 15px;
    }
    
    .login-btn,
    .register-btn {
      padding: 8px 20px;
      font-size: 14px;
    }
  }

  @media (max-width: 768px) {
    .navbar {
      height: 60px;
    }
    
    .navbar-container {
      padding: 0 10px;
    }
    
    .logo {
      margin-right: 15px;
      font-size: 16px;
    }
    
    .logo img {
      height: 28px;
    }
    
    .nav-menu {
      gap: 10px;
    }
    
    .nav-item {
      font-size: 14px;
      padding: 3px 8px;
    }
    
    .navbar-right {
      gap: 10px;
    }
    
    .login-btn,
    .register-btn {
      padding: 6px 16px;
      font-size: 13px;
    }
  }
  /* 用户信息样式 */
  .user-info {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 16px;
    border-radius: 8px;
    transition: all 0.3s ease;
    cursor: pointer;
    white-space: nowrap;
  }

  .user-info .el-avatar {
    border: 1px solid rgba(255, 255, 255, 0.3);
  }
  
  .user-info:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  .username {
    color: white;
    font-size: 16px;
    font-weight: 500;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: all 0.3s ease;
  }
  
  /* 响应式调整 */
  @media (max-width: 1200px) {
    .username {
      font-size: 15px;
      max-width: 100px;
    }
    
    .user-info {
      gap: 10px;
      padding: 6px 14px;
    }
  }
  
  @media (max-width: 1024px) {
    .username {
      font-size: 14px;
      max-width: 80px;
    }
    
    .user-info {
      gap: 8px;
      padding: 5px 12px;
    }
  }
  
  @media (max-width: 768px) {
    .username {
      font-size: 13px;
      max-width: 60px;
    }
    
    .user-info {
      gap: 6px;
      padding: 4px 10px;
    }
  }

  /* 汉堡菜单样式 */
  .hamburger-btn {
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    margin-left: 20px;
    z-index: 15; /* 高于导航栏但不会覆盖页面内容 */
    position: relative;
  }

  .hamburger-btn span {
    display: block;
    width: 24px;
    height: 2px;
    background-color: white;
    margin: 3px 0;
    transition: all 0.3s ease;
    transform-origin: center;
  }

  .hamburger-btn.active span:nth-child(1) {
    transform: rotate(45deg) translate(6px, 6px);
  }

  .hamburger-btn.active span:nth-child(2) {
    opacity: 0;
  }

  .hamburger-btn.active span:nth-child(3) {
    transform: rotate(-45deg) translate(6px, -6px);
  }

  /* 遮罩层样式 */
  .menu-overlay {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 5; /* 低于导航栏，不会覆盖页面内容 */
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none; /* 默认不响应点击事件 */
  }

  .menu-overlay.active {
    opacity: 1;
    pointer-events: auto; /* 激活时才响应点击事件 */
  }

  /* 手机端响应式设计 */
  @media (max-width: 768px) {
    .hamburger-btn {
      display: flex;
    }

    .nav-menu {
      position: fixed;
      top: 60px;
      left: 0;
      width: 100%;
      background-color: #191919;
      flex-direction: column;
      align-items: center;
      padding: 0;
      transform: translateY(-100%);
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease;
      z-index: 20; /* 高于导航栏但不会覆盖页面内容 */
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
      max-height: calc(100vh - 60px);
      overflow-y: auto;
    }

    .nav-menu.active {
      transform: translateY(0);
      opacity: 1;
      visibility: visible;
    }

    .nav-item {
      width: 100%;
      text-align: center;
      padding: 15px 20px;
      font-size: 18px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    .nav-item:last-child {
      border-bottom: none;
    }

    .menu-overlay {
      display: block;
    }

    .auth-buttons {
      flex-direction: row;
      gap: 10px;
    }

    .login-btn,
    .register-btn {
      width: auto;
      text-align: center;
      padding: 8px 16px;
      font-size: 14px;
    }

    .user-info {
      flex-direction: column;
      text-align: center;
    }

    .username {
      max-width: none;
    }
  }

  @media (max-width: 480px) {
    .navbar-container {
      padding: 0 10px;
    }

    .logo {
      font-size: 16px;
      margin-right: 15px;
    }

    .logo img {
      height: 30px;
    }

    .nav-item {
      font-size: 16px;
      padding: 12px 20px;
    }
  }
</style>